import { createAction } from '@reduxjs/toolkit';
import { Favorite, IFavorite, RenamePlace } from './model';

export const loadFavoritesStarted = createAction<void>(
  'creativeHub/favorite/LOAD_FAVORITES_STARTED',
);
export const loadFavoritesSuccess = createAction<{ list: IFavorite[] }>(
  'creativeHub/favorite/LOAD_FAVORITES_SUCCESS',
);
export const loadFavoritesError = createAction<{ error: any }>(
  'creativeHub/favorite/LOAD_FAVORITES_ERROR',
);
export const toggleClicked = createAction<void>('creativeHub/favorite/TOGGLE_CLICKED');
export const deleteClicked = createAction<{ favoriteId: number }>(
  'creativeHub/favorite/DELETE_CLICKED',
);
export const deleteFavoriteStarted = createAction<{ favorite: Favorite }>(
  'creativeHub/favorite/DELETE_FAVORITE_STARTED',
);
export const deleteFavoriteSuccess = createAction<{ result: any; favorite: Favorite }>(
  'creativeHub/favorite/DELETE_FAVORITE_SUCCESS',
);
export const deleteFavoriteError = createAction<{ favorite: Favorite }>(
  'creativeHub/favorite/DELETE_FAVORITE_ERROR',
);
export const addFavoriteStarted = createAction<{ nodeId: number }>(
  'creativeHub/favorite/ADD_FAVORITE_STARTED',
);
export const addFavoriteSuccess = createAction<{ fav: IFavorite; nodeId: number }>(
  'creativeHub/favorite/ADD_FAVORITE_SUCCESS',
);
export const addFavoriteError = createAction<{ error: any; nodeId: number }>(
  'creativeHub/favorite/ADD_FAVORITE_ERROR',
);
export const renameClicked = createAction<{
  favoriteId: number;
  nodeName: string;
  place: RenamePlace;
}>('creativeHub/favorite/RENAME_CLICKED');
export const renameChanged = createAction<{ text: string }>('creativeHub/favorite/RENAME_CHANGED');
export const renameCanceled = createAction<void>('creativeHub/favorite/RENAME_CANCELED');
export const renameInputHidden = createAction<void>('creativeHub/favorite/RENAME_INPUT_HIDDEN');
export const renameConfirmed = createAction<void>('creativeHub/favorite/RENAME_CONFIRMED');
export const renamed = createAction<{ favoriteId: number; name: string }>(
  'creativeHub/favorite/RENAMED',
);
export const renameStarted = createAction<{ favoriteId: number }>(
  'creativeHub/favorite/RENAME_STARTED',
);
export const renameFinished = createAction<{ favoriteId: number }>(
  'creativeHub/favorite/RENAME_FINISHED',
);
